// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cart-modal {
  position: fixed;
  top: 0;
  right: -450px;
  width: 450px;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-out;
}

.cart-modal.open {
  right: 0;
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E8D5B7;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
}

.cart-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
}

.cart-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.cart-close-btn:hover {
  background: rgba(61, 24, 24, 0.1);
}

.cart-close-btn svg {
  width: 20px;
  height: 20px;
  color: #3D1818;
}

.cart-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cart-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  color: #8B7355;
}

.cart-empty svg {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  color: #D4A574;
}

.cart-empty p {
  font-size: 1.1rem;
  margin: 0;
}

.cart-items {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.cart-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #FAF6E7;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
}

.cart-item-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 8px;
  background: white;
}

.cart-item-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cart-item-details h4 {
  margin: 0;
  font-size: 0.95rem;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  line-height: 1.3;
}

.cart-item-price {
  font-size: 0.9rem;
  font-weight: 600;
  color: #7B2323;
  margin: 0;
}

.cart-item-price-old {
  color: #8B7355;
  text-decoration: line-through;
  margin-right: 8px;
  font-size: 0.8rem;
}

.cart-item-price-promo {
  color: #B22222;
}

.cart-item-promo-note {
  font-size: 0.75rem;
  font-weight: 600;
  color: #B22222;
  margin: 2px 0 0;
}

.cart-savings {
  margin: -8px 0 16px;
  text-align: right;
  font-size: 0.9rem;
  font-weight: 600;
  color: #B22222;
}

.cart-item-quantity {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
}

.cart-item-quantity button {
  width: 28px;
  height: 28px;
  border: 1px solid #D4A574;
  background: white;
  color: #3D1818;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.cart-item-quantity button:hover {
  background: #D4A574;
  color: white;
}

.cart-item-quantity span {
  min-width: 24px;
  text-align: center;
  font-weight: 600;
  color: #3D1818;
}

.cart-item-remove {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
  color: #8B7355;
}

.cart-item-remove:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #DC3545;
}

.cart-item-remove svg {
  width: 14px;
  height: 14px;
}

.cart-footer {
  padding: 20px 24px;
  border-top: 1px solid #E8D5B7;
  background: #FAF6E7;
}

.cart-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
}

.cart-total-price {
  color: #7B2323;
  font-size: 1.4rem;
}

.cart-checkout-btn {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);
}

.cart-checkout-btn:hover {
  background: linear-gradient(135deg, #8B2828 0%, #4D2020 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);
}

.cart-clear-btn {
  width: 100%;
  padding: 10px 24px;
  background: transparent;
  color: #8B7355;
  border: 1px solid #D4A574;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cart-clear-btn:hover {
  background: rgba(212, 165, 116, 0.1);
  color: #7B2323;
  border-color: #7B2323;
}

/* Responsive */
@media (max-width: 768px) {
  .cart-modal {
    width: 100%;
    right: -100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/CartModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".cart-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.cart-modal {\n  position: fixed;\n  top: 0;\n  right: -450px;\n  width: 450px;\n  height: 100vh;\n  background: white;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  transition: right 0.3s ease-out;\n}\n\n.cart-modal.open {\n  right: 0;\n}\n\n.cart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E8D5B7;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n}\n\n.cart-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n}\n\n.cart-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n.cart-close-btn:hover {\n  background: rgba(61, 24, 24, 0.1);\n}\n\n.cart-close-btn svg {\n  width: 20px;\n  height: 20px;\n  color: #3D1818;\n}\n\n.cart-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cart-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n  color: #8B7355;\n}\n\n.cart-empty svg {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 16px;\n  color: #D4A574;\n}\n\n.cart-empty p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.cart-items {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.cart-item {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #FAF6E7;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  position: relative;\n}\n\n.cart-item-image {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: white;\n}\n\n.cart-item-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cart-item-details h4 {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  line-height: 1.3;\n}\n\n.cart-item-price {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #7B2323;\n  margin: 0;\n}\n\n.cart-item-price-old {\n  color: #8B7355;\n  text-decoration: line-through;\n  margin-right: 8px;\n  font-size: 0.8rem;\n}\n\n.cart-item-price-promo {\n  color: #B22222;\n}\n\n.cart-item-promo-note {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #B22222;\n  margin: 2px 0 0;\n}\n\n.cart-savings {\n  margin: -8px 0 16px;\n  text-align: right;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #B22222;\n}\n\n.cart-item-quantity {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: auto;\n}\n\n.cart-item-quantity button {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #D4A574;\n  background: white;\n  color: #3D1818;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.cart-item-quantity button:hover {\n  background: #D4A574;\n  color: white;\n}\n\n.cart-item-quantity span {\n  min-width: 24px;\n  text-align: center;\n  font-weight: 600;\n  color: #3D1818;\n}\n\n.cart-item-remove {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n  color: #8B7355;\n}\n\n.cart-item-remove:hover {\n  background: rgba(220, 53, 69, 0.1);\n  color: #DC3545;\n}\n\n.cart-item-remove svg {\n  width: 14px;\n  height: 14px;\n}\n\n.cart-footer {\n  padding: 20px 24px;\n  border-top: 1px solid #E8D5B7;\n  background: #FAF6E7;\n}\n\n.cart-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n}\n\n.cart-total-price {\n  color: #7B2323;\n  font-size: 1.4rem;\n}\n\n.cart-checkout-btn {\n  width: 100%;\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);\n}\n\n.cart-checkout-btn:hover {\n  background: linear-gradient(135deg, #8B2828 0%, #4D2020 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);\n}\n\n.cart-clear-btn {\n  width: 100%;\n  padding: 10px 24px;\n  background: transparent;\n  color: #8B7355;\n  border: 1px solid #D4A574;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cart-clear-btn:hover {\n  background: rgba(212, 165, 116, 0.1);\n  color: #7B2323;\n  border-color: #7B2323;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .cart-modal {\n    width: 100%;\n    right: -100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
